import { darken, lighten, transparentize } from 'polished';
import styled from 'styled-components';

export const Center = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
`;

export const Container = styled.div`
  width: 75%;
  max-width: 500px;
  height: 300px;
  display: flex;
  flex-direction: column;
  z-index: 10;

  @media (max-width: ${({ theme }) => theme.metrics.tablet_small}) {
    min-width: 90%;
    height: 300px;
  }
`;

export const Header = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
  padding: 10px;
  border-top-left-radius: ${({ theme }) => theme.metrics.radius};
  border-top-right-radius: ${({ theme }) => theme.metrics.radius};
  border-bottom: 1px solid ${({ theme }) => theme.colors.background};
  background-color: ${({ theme }) => lighten(0.05, theme.colors.background)};
  pointer-events: painted;
`;

export const Title = styled.h1`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textBackground};
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  background-color: ${({ theme }) => lighten(0.05, theme.colors.background)};
`;

export const Message = styled.p`
  padding: 10px 20px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  font-size: 16px;
  background-color: ${({ theme }) => transparentize(0.7, theme.colors.error)};
  color: ${({ theme }) => theme.colors.error};
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 5px;
  border-top: 1px solid ${({ theme }) => theme.colors.background};
  border-bottom-left-radius: ${({ theme }) => theme.metrics.radius};
  border-bottom-right-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => lighten(0.05, theme.colors.background)};
`;
